import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';

interface FullWidthSublayoutProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
}

export const Default = (props?: FullWidthSublayoutProps) => {
  return (
    props?.rendering && <Placeholder name="full-width-sublayout" rendering={props.rendering} />
  );
};
